/**
 * Mappa nome inglese nazionalità → codice ISO 3166-1 alpha-2 (lowercase),
 * usato dalle CDN di bandiere come https://flagcdn.com/16x12/<iso>.png
 *
 * Lista derivata dai valori `nationality` presenti in PES DB (in inglese).
 * Cosi includiamo solo i paesi davvero osservati nel dataset + un set comune.
 */
const COUNTRY_ISO2 = {
    "Argentina": "ar", "Australia": "au", "Austria": "at",
    "Belgium": "be", "Bolivia": "bo", "Bosnia and Herzegovina": "ba",
    "Brazil": "br", "Bulgaria": "bg", "Cameroon": "cm",
    "Canada": "ca", "Chile": "cl", "China": "cn",
    "Colombia": "co", "Costa Rica": "cr", "Croatia": "hr",
    "Czech Republic": "cz", "Czechia": "cz",
    "Denmark": "dk", "Dominican Republic": "do", "Ecuador": "ec",
    "Egypt": "eg", "England": "gb-eng",
    "Equatorial Guinea": "gq", "Estonia": "ee", "Finland": "fi",
    "France": "fr", "Gabon": "ga", "Georgia": "ge",
    "Germany": "de", "Ghana": "gh", "Greece": "gr",
    "Guinea": "gn", "Guinea-Bissau": "gw",
    "Honduras": "hn", "Hungary": "hu", "Iceland": "is",
    "India": "in", "Iran": "ir", "Iraq": "iq",
    "Ireland": "ie", "Israel": "il", "Italy": "it",
    "Ivory Coast": "ci", "Côte d'Ivoire": "ci",
    "Jamaica": "jm", "Japan": "jp",
    "Kenya": "ke", "Korea Republic": "kr", "South Korea": "kr",
    "Kosovo": "xk", "Liechtenstein": "li", "Luxembourg": "lu",
    "Madagascar": "mg", "Mali": "ml", "Malta": "mt",
    "Mauritania": "mr", "Mexico": "mx", "Montenegro": "me",
    "Morocco": "ma", "Netherlands": "nl", "New Zealand": "nz",
    "Nigeria": "ng", "North Macedonia": "mk", "Norway": "no",
    "Northern Ireland": "gb-nir",
    "Panama": "pa", "Paraguay": "py", "Peru": "pe",
    "Philippines": "ph", "Poland": "pl", "Portugal": "pt",
    "Qatar": "qa", "Romania": "ro", "Russia": "ru",
    "Saudi Arabia": "sa", "Scotland": "gb-sct",
    "Senegal": "sn", "Serbia": "rs", "Sierra Leone": "sl",
    "Slovakia": "sk", "Slovenia": "si", "South Africa": "za",
    "Spain": "es", "Sweden": "se", "Switzerland": "ch",
    "Syria": "sy", "Tanzania": "tz", "Togo": "tg",
    "Tunisia": "tn", "Turkey": "tr", "Türkiye": "tr",
    "Ukraine": "ua", "United States": "us", "USA": "us",
    "Uruguay": "uy", "Uzbekistan": "uz", "Venezuela": "ve",
    "Wales": "gb-wls",
    "DR Congo": "cd", "Cape Verde": "cv", "Algeria": "dz",
    "Albania": "al", "Angola": "ao", "Armenia": "am",
    "Azerbaijan": "az", "Belarus": "by", "Burkina Faso": "bf",
    "Burundi": "bi", "Benin": "bj", "Cyprus": "cy",
    "Guatemala": "gt", "Haiti": "ht", "Indonesia": "id",
    "Kazakhstan": "kz", "Latvia": "lv", "Lithuania": "lt",
    "Mozambique": "mz", "Niger": "ne", "Suriname": "sr",
    "Thailand": "th", "Trinidad and Tobago": "tt", "Uganda": "ug",
    "Zambia": "zm", "Zimbabwe": "zw",
    "Central African Republic": "cf",
    "Central African Rep.": "cf",
    "Congo": "cg", "Republic of the Congo": "cg",
    "Comoros": "km", "Eritrea": "er", "Ethiopia": "et",
    "Gambia": "gm", "Lebanon": "lb", "Libya": "ly",
    "Liberia": "lr", "Malawi": "mw", "Moldova": "md",
    "Namibia": "na", "Palestine": "ps", "Rwanda": "rw",
    "Somalia": "so", "Sudan": "sd", "South Sudan": "ss",
    "Tajikistan": "tj", "Turkmenistan": "tm", "Vietnam": "vn",
    "Curaçao": "cw", "Curacao": "cw",
    "Faroe Islands": "fo", "Greenland": "gl",
    "Jordan": "jo", "Bahrain": "bh", "Kuwait": "kw",
    "United Arab Emirates": "ae", "UAE": "ae", "Oman": "om",
    "Yemen": "ye", "Pakistan": "pk", "Bangladesh": "bd",
    "Myanmar": "mm", "Malaysia": "my", "Singapore": "sg",
    "Hong Kong": "hk", "Taiwan": "tw",
    "São Tomé and Príncipe": "st", "Mauritius": "mu",
    "Saint Lucia": "lc", "Saint Kitts and Nevis": "kn",
    "Barbados": "bb", "Bahamas": "bs", "Antigua and Barbuda": "ag",
    "Grenada": "gd",
};

/** Returns the FlagCDN URL for a country name, or null if unknown. */
export function flagUrl(country, size = "16x12") {
    if (!country) return null;
    const iso = COUNTRY_ISO2[country];
    if (!iso) return null;
    return `https://flagcdn.com/${size}/${iso}.png`;
}

/** Returns the ISO2 (or sub-region) code for a country name. */
export function countryIso(country) {
    return country ? (COUNTRY_ISO2[country] || null) : null;
}
